import PropTypes from "prop-types";
import {debounce} from "../../util/util";

const CustomTextarea = ({label, id, name, className, placeholder, inputHandler, pattern, maxLength, areaHeight}) => {

    const debounceHandler = debounce(inputHandler, 500);

    return (
        <>
            <textarea
                name={name}
                className={className}
                placeholder={placeholder} id={id}
                style={{height: areaHeight, resize: 'none' }}
                maxLength={maxLength}
                pattern={pattern}
                onInput={(event) => {debounceHandler(event.target.value)}}
                ></textarea>
            <label htmlFor="floatingTextarea2">{label}</label>
        </>
    );
}

CustomTextarea.propTypes = {
    label: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    inputHandler: PropTypes.func.isRequired,
    pattern: PropTypes.string.isRequired,
    maxLength: PropTypes.number.isRequired,
    areaHeight: PropTypes.string.isRequired
};

CustomTextarea.defaultProps = {
    label: "",
    id: "floatingTextarea2",
    name: "",
    className: "form-control",
    placeholder: "",
    inputHandler: () => {},
    pattern: ".*",
    maxLength: 300,
    areaHeight: '500px',
};

export default CustomTextarea;